var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/library/modules/_html.js
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7